import Card from '../../../../shared/types/props/card';
import EventProgressBar from '../progressBar/eventProgressBar';
import HorizontalCard from './horizontalCard';
import useList from '../../../../shared/components/utils/hooks/useList';
import Colors from '../../../../shared/assets/style/default/color';

const ITEMS_TO_DISPLAY = 5;

function EventCard({ item, index, onClick, releaseAction }: Card) {
  const { distanceToIndex } = useList(index);
  let currentEvent = false;
  let percentage = 0;

  if (
    distanceToIndex < ITEMS_TO_DISPLAY &&
    distanceToIndex > -ITEMS_TO_DISPLAY
  ) {
    const progress = item.date ? Date.now() - item.date.start : undefined;
    const totalDuration = item.date
      ? item.date.end - item.date.start
      : undefined;
    currentEvent = item.isCurrentEvent() && !item.mocked;
    percentage =
      progress && totalDuration ? (progress / totalDuration) * 100 : 0;
  }

  return (
    <HorizontalCard
      index={index}
      item={item}
      releaseAction={onClick || releaseAction}
      progressBar={currentEvent && percentage > 0}
    >
      <>
        {currentEvent ? (
          <EventProgressBar
            percentage={percentage}
            color={Colors.progress.fill}
          ></EventProgressBar>
        ) : null}
      </>
    </HorizontalCard>
  );
}

export default EventCard;
